import Currency from "./Currency";

export default class Budget
{
    constructor( options = {} )
    {
        this.setOptions(options);
    }

    setOptions( options = {} )
    {
        this.type         = options.type               || null;
        this.currency     = options.currency           || 'EUR';
        this.exchange     = parseFloat(options.exchange);
        this.min_format   = options.min_format         || null;
        this.max_format   = options.max_format         || null;
        this.label        = options.label              || null;

        this.min          = options.min ? parseInt(options.min) : null;
        this.max          = options.max ? parseInt(options.max) : null;
        this.avg          = options.avg ? parseInt(options.avg) : null;

    }

    toJson()
    {
        return {
            type        : this.type,
            currency    : this.currency,
            exchange    : this.exchange,
            min         : this.min,
            max         : this.max,
            avg         : this.avg,
            min_format  : this.min_format,
            max_format  : this.max_format,
            label       : this.label,
        }
    }

    getLabel()
    {

        let min    = new Currency( { 'value' : this.min, 'code' : this.currency }),
            max    = new Currency( { 'value' : this.max, 'code' : this.currency });

        if ( this.min && this.max ) {

            return printf('%s - %s', min.label(), max.label() );

        } else if ( this.min && !this.max ){

            return '>' + min.label();

        } else if ( this.max && !this.min ){

            return '<' + max.label();
        }

        return '';
    }
}


// WEBPACK FOOTER //
// ./resources/js/models/Budget.js